/* Two registers on purpose. The quiet one is a footnote — it states a fact the
   operator should be able to find, not one that should interrupt them. The
   alert one uses the same treatment as DegradationBanner, because a tenant
   mismatch is the same class of thing: a claim about the outside world that
   changes how the screen should be read. */

.quiet {
  margin: 0;
  padding: 0.375rem 1rem;
  color: var(--muted);
  font-family: var(--font-body);
  font-size: var(--text-min-body);
}

.alert {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0;
  padding: 0.75rem 1rem;
  background: color-mix(in srgb, var(--stop) 10%, var(--paper));
  border: 1px solid var(--stop);
  border-radius: var(--radius-sharp);
  color: var(--ink);
  font-family: var(--font-body);
  font-size: var(--text-min-body);
}

/* `margin: 0` on the container does not reach the paragraphs inside it —
   the reset leaves their default block margin, which swamped the 0.25rem
   gap and floated the caveat away from the claim it qualifies. */
.alert p {
  margin: 0;
}

.tenant {
  font-family: var(--font-mono, monospace);
}

.caveat {
  color: var(--muted);
}
